module.exports = __webpack_public_path__ + "static/media/chapter-two-spheres.50c9093c.png";